/* eslint-disable */
import { produce } from "immer";
import {
  PENSION_LAB_CONSENT_UPDATE_FETCH_START,
  PENSION_LAB_CONSENT_UPDATE_FETCH_SUCCESS,
  PENSION_LAB_CONSENT_UPDATE_FETCH_FAILURE,
} from "../actions/types";

const updatePensionLabConsentReducer = (
  state = {
    updatePensionLabConsentFetching: false,
    updatePensionLabConsentData: [],
    updatePensionLabConsentError: null,
  },
  action,
) => {
  switch (action.type) {
    case PENSION_LAB_CONSENT_UPDATE_FETCH_START:
      return produce(state, (draft) => {
        draft.updatePensionLabConsentFetching = true;
      });
    case PENSION_LAB_CONSENT_UPDATE_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.updatePensionLabConsentFetching = true;
        draft.updatePensionLabConsentData = action.data;
        draft.updatePensionLabConsentFetching = false;
      });
    case PENSION_LAB_CONSENT_UPDATE_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.updatePensionLabConsentFetching = false;
        draft.updatePensionLabConsentError = action.error;
      });
    default:
      return state;
  }
};

export default updatePensionLabConsentReducer;
